module.exports = __webpack_public_path__ + "static/media/grabaseat6_preview.e99cfe0b.jpg";